import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import AuthRUService from "../../services/Auth/AuthRUService";
import { Loading } from '../../components';
import { toast } from 'react-toastify';

import './styles.scss';

const CompleteAuthCallback = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);

        const code = urlParams.get("code");
        const state = urlParams.get("state");
        const loginSession = urlParams.get("login_session");

        // CASO SESSÃO UNIFICADA (Sem MFA)
        if (loginSession) {
            AuthRUService.finalizarLoginComSessao(loginSession)
                .then(success => {
                    if (success) {
                        navigate("/");
                        window.location.hash = "cursos";
                    } else {
                        toast.error('Sessão inválida ou expirada.');
                        navigate("/login");
                    }
                })
                .finally(() => setLoading(false));
            return;
        }

        // CASO MFA (Microsoft)
        if (code && state) {
            AuthRUService.completeMfa({ code, state })
                .then(success => {
                    if (success) {
                        navigate("/");
                        window.location.hash = "cursos";
                    } else {
                        toast.error('Erro ao concluir autenticação MFA.');
                        navigate("/login");
                    }
                })
                .catch(() => {
                    toast.error('Ocorreu um erro inesperado ao autenticar.');
                    navigate("/login");
                })
                .finally(() => setLoading(false));
            return;
        }

        // SEM PARÂMETROS
        setLoading(false);
        navigate("/login");

    }, [navigate, location]);

    return (
        <>
            {loading && <Loading />}
            <div className="not-found">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-5 col-lg-6 col-md-7">
                            <div className="text-center">
                                <h1 className="display-1 text-primary">⏳</h1>
                                <p><strong>Processando sua autenticação...</strong></p>
                                <p>Aguarde um momento enquanto preparamos seu acesso.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CompleteAuthCallback;